import type { ResponseError } from 'superagent';
import Superagent from 'superagent';

import type { ImplProps, ImplResponse } from './api-request';

function isSuperagentError(
  responseError: unknown
): responseError is ResponseError {
  if (
    responseError &&
    typeof responseError === 'object' &&
    'response' in responseError
  ) {
    return true;
  }
  return false;
}

export async function apiSuperAgentRequest({
  body,
  fullDomain,
  headers,
  method,
}: ImplProps): Promise<ImplResponse> {
  try {
    const requestObj = Superagent(method.toUpperCase(), fullDomain)
      .set({
        ...(body instanceof FormData
          ? {}
          : { 'Content-Type': 'application/json' }),
        ...headers,
      })
      .withCredentials();

    const response = await requestObj.send(body);

    return {
      ok: true,
      status: response.status,
      body: response.body || undefined,
      text: typeof response.text === 'string' ? response.text : '',
      response,
    };
  } catch (e) {
    if (!e || !isSuperagentError(e)) {
      throw new Error(e instanceof Error ? e.message : String(e), {
        cause: e,
      });
    }

    const { response } = e;

    return {
      ok: false,
      status: response?.status,
      body: response?.body,
      text: '',
      response,
    };
  }
}
